package link.erpango.quip.core.factory

import androidx.compose.runtime.Composable
import androidx.lifecycle.ViewModelStoreOwner
import androidx.lifecycle.viewmodel.compose.viewModel
import link.erpango.quip.domain.entities.DVehicle
import link.erpango.quip.domain.usecases.IGarageUseCase
import link.erpango.quip.features.garage.GarageViewModel
import link.erpango.quip.features.maintenances.MaintenancesViewModel
import link.erpango.quip.features.transfer.TransferViewModel

class GarageFactory (
    private val garageInteractor: IGarageUseCase,
    private val viewModelStoreOwner : ViewModelStoreOwner
): IFactory {

    @Composable
    fun createGarageViewModel(): GarageViewModel {
        return viewModel(viewModelStoreOwner) {
            GarageViewModel(garageInteractor)
        }
    }

    @Composable
    fun createMaintenancesViewModel(vehicle: DVehicle): MaintenancesViewModel {
        return viewModel(viewModelStoreOwner, vehicle.vin) {
            MaintenancesViewModel(vehicle, garageInteractor)
        }
    }

    @Composable
    fun createTransferViewModel(vehicleVin: String? = null): TransferViewModel {
        return viewModel(viewModelStoreOwner, "transfer_${vehicleVin ?: "default"}") {
            TransferViewModel(garageInteractor, vehicleVin)
        }
    }
}